/* eslint-disable consistent-return */
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  StyledEngineProvider,
  Typography,
} from '@mui/material';
import Biotif from '@styles/Font';
import classNames from 'classnames';
import { memo, useRef } from 'react';
import ComparisonTable from '../ComparisonTable';
import { ComparisonDropdownProps } from './ComparisonDropdown.types';
import styles from './styles.module.scss';

// custom styles for mui
const accordionStyle = {
  boxShadow: 'none',
  backgroundColor: 'transparent',
  '&:before': {
    display: 'none',
  },
  ':last-of-type': {
    borderRadius: 0,
  },
  '&.Mui-expanded:last-of-type': {
    marginBottom: '3.2rem',
  },
  marginBottom: '3.2rem',
};

const accordionDetailsStyle = {
  padding: '0',
};

const ComparisonDropdown = memo<ComparisonDropdownProps>(({ section, details }) => {
  const accordionRef = useRef<HTMLDivElement>(null);

  return (
    <StyledEngineProvider injectFirst>
      <Accordion
        sx={accordionStyle}
        disableGutters
        defaultExpanded
        TransitionProps={{
          onEnter: () => {
            if (!accordionRef.current) return;
            accordionRef.current.style.borderBottomLeftRadius = '0';
            accordionRef.current.style.borderBottomRightRadius = '0';
          },
          onExited: () => {
            if (!accordionRef.current) return;
            accordionRef.current.style.borderBottomLeftRadius = '1.6rem';
            accordionRef.current.style.borderBottomRightRadius = '1.6rem';
          },
        }}
      >
        <AccordionSummary
          id={section}
          ref={accordionRef}
          aria-controls={section}
          expandIcon={<KeyboardArrowDownIcon className={styles.arrow} />}
          className={styles.accordionSummary}
        >
          <Typography className={classNames(Biotif.className, styles.accordionSection)}>
            {section}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={accordionDetailsStyle}>
          {section === 'App Features' ? (
            <ComparisonTable />
          ) : (
            <Typography className={classNames(Biotif.className, styles.accordionAnswer)}>
              {details}
            </Typography>
          )}
        </AccordionDetails>
      </Accordion>
    </StyledEngineProvider>
  );
});

export default ComparisonDropdown;
